<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title}}</myhead>
  <div ref="wrapper" @scroll.passive="isScrollBottom" class="scroll" style="height:calc(100vh - 48px)">
    <div v-if="errMessage" class="center">
      <van-empty :description="errMessage" />
    </div>
    <div v-else class="ml15 mr15">
      <p class="relative">提问者:{{detail.nickname}}
        <van-badge class="opacity4 b100 size13 absolute r t mt4" :content="detail.follow_count+'人关注'" color="gray" v-show="detail.follow_count" />
      </p>
      <p class="size12 mt5 C999">{{detail.add_time}}</p>
      <p class="b500 mt15 mb14">{{detail.title}}</p>
      {{detail.content}}
      <div v-if="detail.answer" class="mb5 mt15">
        <p class="C000 b500 mb5">雾森官方：</p>
        {{detail.answer}}
      </div>
      <p v-show="detail.answer" class="mb8 size14 opacity5 size12">{{detail.answer_time}}</p>
      <hr class="mt20 opacity5">
      <p class="size16 mt20 mb10" v-if="detail.answer">
        评论<span class="size12">({{detail.total}})</span>
      </p>
      <div class="flex between" v-if="detail.answer">
        <input type="text" v-model="content" class="BGf5 block width80 height32px radius20" @keyup.enter="comment" placeholder="写评论"
          style="padding-left:18px" />
        <div>
          <van-button type="primary" round class="height32px" @click="handleComment">评论</van-button>
        </div>
      </div>
    </div>
    <ul class="pad15 mt20">
      <li v-for="item,index in list" :key="index" class="mb25 flex start">
        <img :src="item.head_pic" :onerror="imgError" class="height36px BGf0 width36px radius40 pointer" alt="">
        <div class="flex1 ml10 relative">
          <!-- <div class="absolute r b flex size12 Cccc" @click="item.comment=!item.comment">
            <img src="@/assets/img/shop4.png" class="height20px mr4" alt="">{{item.comment?'取消':'我要回复'}}
          </div> -->
          <p class="b500 mb10 size14 ellipsis">{{item.nickname}}</p>
          <p @click="item.comment=!item.comment">{{ item.content }}</p>
          <p class="mt10 size14 C999">{{ item.add_time }}</p>
        </div>
        <div class="BGf8 width100 ml40 pad5 C999 mt5 radius5" v-if="item.reply_count && !item.list" @click="getList(1,item.id,index)">
          <p class="ml8 size12">共{{item.reply_count}}条回复&nbsp; &gt;</p>
        </div>
        <div class="flex width100 mt5 ml40 nowrap" v-if="item.comment">
          <div class="input_box BGf5">
            <input type="text" placeholder="请输入" v-model="item.contentInput" @keyup.enter="comment(item.id,index)"
              class="BGf5 pad5 radius5 flex1 height30px" style="padding-left:15px;width:100%">
            <img v-if="item.contentInput" src="@/assets/img/icon32.png" class="width22px height22px pad6 BGwhite pointer radius20 opacity7 ml6 mr6"
              alt="" @click="item.contentInput = '',item.comment = !item.comment" />
            <div v-else class="width22px  pad2 ml10 pointer mr10"></div>

          </div>
          <div class="BGon line30 Cfff ml8 wrap size13 center radius4" style="min-width:50px" type="primary" @click="comment(item.id,index)">回复</div>
        </div>
        <div class="input_list BGf8 mt5 width100 ml40 radius5" v-if="item.list && item.list.length">
          <div class="pad12 " v-for="child,childIndex in item.list" :key="childIndex">
            <hr class="mb18 opacity5" v-if="childIndex!=0">
            <p class="flex nowrap mb8"><img src="" class="height20px width20px radius20 BGwhite mr5" :onerror="userError">{{child.nickname}}</p>
            <p class="input_content">{{child.content}}</p>
            <p class="size12 C999 mt8">{{child.add_time}}</p>
          </div>
        </div>
      </li>
    </ul>
    <van-empty v-if="list.length==0 && detail.answer">暂无数据</van-empty>
  </div>

  <div @click="$router.push({ path:'/feedback',query:{column_type:5,common_id:$route.query.id,cate_id:$route.query.cate_id }})"
    class="fixed l b mb80 Cfff" style="border-radius:0 20px 20px 0;padding:10px 18px;background:rgba(8,109,143,.45)">意见反馈</div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      errMessage: null,
      content: '',
      list: [],
      detail: {}
    }
  },
  watch: {
  },
  methods: {
    handleComment () {
      let content = this.content;

      this.ajax({
        method: "post",
        url: "forum/onlineforumhandle",
        data: {
          content,
          typeid: 2, id: this.$route.query.id
        },
        myData: {
          showMsg: true
        }
      }).then(() => {
        this.content = ''
        this.getList()
      })
    },
    comment (parent_id = 0, index = 0) {
      let content = this.content;

      if (parent_id) {
        content = this.list[index].contentInput;
      }

      this.ajax({
        method: "post",
        url: "forum/onlineforumhandle",
        data: {
          content,
          parent_id,
          typeid: 2, id: this.$route.query.id
        },
        myData: {
          showMsg: true
        }
      }).then(() => {
        if (parent_id) {
          this.list[index] = { ...this.list[index], contentInput: '', comment: false }
          this.getList(1, parent_id, index)
        } else {
          this.content = ''
          this.getList()
        }
      })
    },
    next () {
      if (this.detail.is_deliver) {
        return this.$router.back()
      }
      if (this.detail.is_concept == 0) {
        this.$router.push({ path: '/join/sense', query: { ...this.$route.query } })
      } else {
        this.$router.push({ path: '/join/edit', query: { ...this.$route.query } })
      }
    },
    isScrollBottom () {
      // 是否滚动到了底部
      this.box = this.$refs.wrapper
      var clientHeight = this.box.clientHeight
      var scrollTop = this.box.scrollTop
      var scrollHeight = this.box.scrollHeight
      if (scrollTop + clientHeight == scrollHeight) {
        this.getList(this.page + 1);
      }
    },
    getList (page, parent_id = 0, index = 0) {
      this.page = page || this.page;
      let list = this.list;
      if (this.page > 1) {
        if (this.page > this.count) {
          return this.page = this.count;
        }
      } else {
        list = [];
      }
      // typeid 1-投票中 2-已回答
      this.ajax.post("forum/commentlist", { page: this.page, forum_id: this.$route.query.id, parent_id }).then(({ data, count }) => {
        data.map(item => {
          item.comment = false;
          item.contentInput = ''
        })
        if (parent_id) {
          this.list[index].list = data;
        } else {
          this.list = list.concat(data);
          this.count = count;
        }
      })
    },
  },
  created () {
    this.$store.state.forumKey++;
    this.ajax.post("forum/onlineforum", { id: this.$route.query.id, cate_id: this.$route.query.cate_id }).catch(({ data }) => {
      let { message } = data;
      this.errMessage = message
    }).then(({ data }) => {
      if (data.answer) {
        this.getList();
      }
      this.detail = data;
    })
  }
}
</script>

<style>
.input_box{
  flex: 1;
  display: flex;
  align-items: center;
}
.input_list{
  width: calc(100% - 40px);
  margin-top: 15px;
  margin-left: 40px;
  overflow: hidden;
  
}
.input_content{
    width: 100%;
    white-space: normal; /* 允许文本自动换行 */
    overflow-wrap: break-word; /* 在单词内换行，确保更好的换行机制 */
    word-wrap: break-word; /* 在单词内换行，确保更好的换行机制 */
  }
</style>
